export default __webpack_public_path__ + "static/VIDA-8f9fcbfbb94df512f8c0d5348e8d2c01.jpg";